import { addressFormatter } from '@dreryk/react-common';

import { HealthcareProviderLocation } from '~libs.shared.healthcare-provider-location';

export const formatVisitLocation = (healthcareProviderLocation: HealthcareProviderLocation): string => {
   return `${healthcareProviderLocation.name}, ${addressFormatter(healthcareProviderLocation.address)}`;
};
